module.exports = __webpack_public_path__ + "img/avatar6.93d9c1a9.png";